<template>
	<div>
		<div class="details-icon" @click="hide"></div>
		<div class="details">
			<div class="details-type">
				<div class="type-text" v-if="type === 'repair' && currentStatus !=='noSuccess'">平台维修量</div>
				<div class="type-text" v-if="type === 'equPage'">平台设备</div>
				<div class="type-text" v-if="type === 'findMaintainExecutingPage'">
					正在保养
				</div>
				<div class="type-text" v-if="type === 'findInspectExecutingPage'">
					正在巡检
				</div>
				<div class="type-text" v-if="type === 'repair' && currentStatus ==='noSuccess'">
					正在维修
				</div>
				<div class="type-text" v-if="type === 'maintainPage'">
					本季度保养统计
				</div>
				<div class="type-text" v-if="type === 'inspectPage'">本月巡检统计</div>
				<div class="type-text" v-if="type === 'equMaintainPage'">保养统计</div>
				<div class="type-text" v-if="type === 'equInspectPage'">巡检统计</div>
				<div class="type-text" v-if="type === 'equPageValue'">设备价值</div>
				<div class="type-text" v-if="type === 'maintenanceType'">维保设备</div>
				<div class="type-text" v-if="type === 'ranking'">工程师</div>
				<div class="type-text" v-if="
            type === 'meteringPage-imperative' ||
            type === 'meteringPage-non_imperative' ||
            type === 'meteringPage'
          ">
					设备计量类型
				</div>

				<!-- <div style="color:#fff">{{type}},,</div>
				<div style="color:#fff">{{currentStatus}}、、</div>
				<div style="color:#fff">{{dataList.length}}\\</div>
				<div style="color:#fff">{{infor.status}}</div> -->
				<!-- <div style="color:#fff">科室{{departId}}</div> -->
        
				<div class="screen">
					<div class="elSelect">
						<!-- 医院 -->
						<el-select v-if="!hospitalId&& hospitalList && hospitalList.length > 0" class="departSelect"
							popper-class="select" v-model="infor.hospitalId" size="mini" filterable clearable
							placeholder="请选择医院" @change="changeHospital">
							<el-option class="option" v-for="(item, index) in hospitalList" :key="index"
								:label="item.hospitalName" :value="item.hospitalId">
							</el-option>
						</el-select>
            <!-- 科室 -->
            <el-select v-if="isDepartment && type != 'ranking'" class="departSelect" popper-class="select" clearable
							placeholder="请选择科室" v-model="infor.departId" size="mini" @change="changeDepartId">
							<el-option class="option" v-for="(item, index) in departList" :key="index"
								:label="item.departName" :value="item.departId">
							</el-option>
						</el-select>
						<!-- 选择工单状态 -->
						<el-select v-if="type === 'repair' && currentStatus !== 'noSuccess'" class="departSelect"
							popper-class="select" v-model="infor.status" size="mini" placeholder="请选择"
							@change="changeStatus">
							<el-option class="option" v-for="(item, index) in repairStatusList" :key="index"
								:label="item.value" :value="item.name">
							</el-option>
						</el-select>
						<!-- 维修工单多少天内未完成 -->
						<el-select v-if="type === 'repair' &&  currentStatus =='allRepair' && dateUnfinished"
							class="departSelect" popper-class="select" v-model="searchParam.many" size="mini" clearable
							@change="changeDays">
							<el-option class="option" v-for="(item, index) in manyUnfinished" :key="index"
								:label="item.name" :value="item.value">
							</el-option>
						</el-select>
						<!-- 选择管理类型 -->

						<el-select
							v-if="type === 'equPage' && currentStatus && (currentStatus ==='management' || currentStatus === 'allEquStatus')"
							class="departSelect" popper-class="select" v-model="searchParam.management_type" size="mini"
							clearable placeholder="请先选择医院" placeholder-style="color:red" @change="changeManagementType">
							<el-option class="option" v-for="(item, index) in managementTypeList" :key="index"
								:label="item.typeName" :value="item.typeId">
							</el-option>
						</el-select>
						<!-- 品类 -->
						<el-select
							v-if=" type === 'equPage' && currentStatus && ( currentStatus.indexOf('06-') != -1 || currentStatus === 'allEquStatus') "
							class="departSelect" popper-class="select" clearable placeholder="请选择"
							v-model="infor.category" size="mini" @change="changeCategory">
							<el-option class="option" v-for="(item, index) in categoryList" :key="index"
								:label="item.name" :value="item.value">
							</el-option>
						</el-select>
						<!--  -->
						<!-- 保修类型 -->
						<el-select v-if="type === 'allEquStatus '|| type === 'maintenanceType'" class="departSelect"
							popper-class="select" clearable placeholder="请选择保修类型"
							v-model="infor.EquMaintainWarrantyStatus" size="mini"
							@change="changeEquMaintainWarrantyStatus">
							<el-option class="option" v-for="(item, index) in equMaintainWarrantyStatusList"
								:key="index" :label="item.value" :value="item.name">
							</el-option>
						</el-select>
						<!-- 正在巡检  -->
						<el-select v-if="type === 'findInspectExecutingPage'" class="departSelect" popper-class="select"
							clearable placeholder="请选择" v-model="searchParam.inspectExecutingStatus" size="mini"
							@change="changeInspectExecutingStatus">
							<el-option class="option" v-for="(item, index) in inspectExecutingList" :key="index"
								:label="item.name" :value="item.value">
							</el-option>
						</el-select>
						<!-- 正在执行巡检 -->
						<el-select v-if="type === 'inspectPage'" class="departSelect" popper-class="select"
							placeholder="请选择" v-model="infor.inspectStatus" size="mini" @change="changeInspectStatus">
							<el-option class="option" v-for="(item, index) in findExecutingInspectStatusList"
								:key="index" :label="item.name" :value="item.value">
							</el-option>
						</el-select>
						<!-- 正在保养  -->
						<el-select v-if="type === 'findMaintainExecutingPage'" class="departSelect"
							popper-class="select" clearable placeholder="请选择"
							v-model="searchParam.maintainExecutingStatus" size="mini"
							@change="changeMaintainExecutingStatus">
							<el-option class="option" v-for="(item, index) in MaintainExecutingList" :key="index"
								:label="item.name" :value="item.value">
							</el-option>
						</el-select>
						<!-- 正在执行保养 -->
						<el-select v-if="type === 'maintainPage'" class="departSelect" popper-class="select"
							placeholder="请选择" v-model="infor.ExecutingMaintainStatus" size="mini"
							@change="changeExecutingMaintainStatus">
							<el-option class="option" v-for="(item, index) in findExecutingMaintainStatusList"
								:key="index" :label="item.name" :value="item.value">
							</el-option>
						</el-select>
						<!-- 计量类型 -->
						<el-select v-if="
                type === 'meteringPage-imperative' ||
                type === 'meteringPage-non_imperative' ||
                type === 'meteringPage'
              " class="departSelect" popper-class="select" clearable placeholder="请选择" v-model="infor.meteringStatus"
							size="mini" @change="changeMeteringStatus">
							<el-option class="option" v-for="(item, index) in measureTypeList" :key="index"
								:label="item.value" :value="item.name">
							</el-option>
						</el-select>
						<!-- 设备价值 -->
						<el-select v-if=" type === 'equPageValue'" class="departSelect" popper-class="select" clearable
							placeholder="请选择" v-model="infor.equValue" size="mini" @change="changeEquValue">
							<el-option class="option" v-for="(item, index) in equValueList" :key="index"
								:label="item.name" :value="item.value">
							</el-option>
						</el-select>
            
						<!-- 拆线图巡检日期选择 -->
						<el-date-picker v-if="type === 'equMaintainPage' || type === 'equInspectPage'"
							class="monthPicker" size="mini" v-model="searchParam.inspectTime" type="month"
							:format="dateFormat" :clearable="false" popper-class="date-picker" @change="changeDateTime">
						</el-date-picker>
					</div>
					<el-button type="primary" class="elButton" @click="query">查询</el-button>
				</div>
			</div>
			<!--  -->
			<div class="list-info">
				<div>
					<!-- 维修type -->
					<div class="list-type" v-if="type === 'repair' || type === 'pageBeingRepaired'">
						<div class="list-type-item" v-for="(item, index) in repairListType" :key="index">
							{{ item }}
						</div>
					</div>
					<!-- 工单type -->
					<div class="list-type" v-if="
              type === 'equPage' ||
              type === 'meteringPage-imperative' ||
              type === 'meteringPage-non_imperative' ||
              type === 'meteringPage' ||
              type === 'equPageValue' ||
              type === 'maintenanceType'
            ">
						<div class="list-type-item" v-for="(item, index) in equPageList" :key="index">
							{{ item }}
						</div>
					</div>
					<!-- 保养type -->
					<div class="list-type" v-if="
              type === 'maintainPage' ||
              type === 'findMaintainExecutingPage' ||
              type === 'equMaintainPage'
            ">
						<div class="list-type-item" v-for="(item, index) in maintainPageList" :key="index">
							{{ item }}
						</div>
					</div>
					<!-- 巡检type -->
					<div class="list-type" v-if="
              type === 'inspectPage' ||
              type === 'findInspectExecutingPage' ||
              type === 'equInspectPage'
            ">
						<div class="list-type-item" v-for="(item, index) in inspectPageList" :key="index">
							{{ item }}
						</div>
					</div>
					<!-- 工程师排行 -->
					<div class="list-type" v-if="type === 'ranking'">
						<div class="list-type-item" v-for="(item, index) in engineerRanking" :key="index">
							{{ item }}
						</div>
					</div>
					<!-- end -->
					<div class="list">
						<!-- 维修list -->
						<div class="list-item" v-if="type === 'repair' || type === 'pageBeingRepaired'">
							<div class="list-item" v-for="(item, index) in dataList" :key="index">
								<div class="cl-item">
									<div class="item-div">{{ item.hospitalName || "-" }}</div>
									<div class="item-div">{{ item.departName || "-" }}</div>
									<div class="item-div">{{ item.equName || "-" }}</div>
									<div class="item-div">{{ item.equModel || "-" }}</div>
									<div class="item-div">{{ item.sn || "-" }}</div>
									<div class="item-div" v-if="item.reportUser">
										{{ item.reportUserName || "-" }}
									</div>
									<div class="item-div">{{ item.createTime || "-" }}</div>
									<div class="item-div">{{ item.repairUserName || "-" }}</div>
									<div class="item-div">{{ item.workHours || "-" }}</div>
									<div class="item-div">
										{{ util.RepairStatus(item.repairStatus) || "-" }}
									</div>
									<div class="item-div">{{ item.closeDate || "-" }}</div>
								</div>
							</div>
						</div>
						<!-- 工单list -->
						<div class="list-item" v-if="
                type === 'equPage' ||
                type === 'meteringPage-imperative' ||
                type === 'meteringPage-non_imperative' ||
                type === 'meteringPage' ||
                type === 'equPageValue' ||
                type === 'maintenanceType'
              ">
							<div class="list-item" v-for="(item, index) in dataList" :key="index">
								<div class="cl-item">
									<div class="item-div">
										{{ item.hospitalDto.hospitalName || "-" }}
									</div>
									<div class="item-div">{{ item.qrCodeContent || "-" }}</div>
									<div class="item-div">
										{{ item.hospitalDepartmentDto.departName || "-" }}
									</div>
									<div class="item-div">{{ item.equName || "-" }}</div>
									<div class="item-div">{{ item.model || "-" }}</div>
									<div class="item-div">{{ item.sn || "-" }}</div>
									<div class="item-div">
										{{
                      item.equMedicalClassificationDTO
                        .medicalClassificationName || "-"
                    }}
									</div>

									<div class="item-div">
										{{ item.equMaintenanceDTO.warrantyStatus || "-" }}
									</div>
									<div class="item-div">{{ item.measureType || "-" }}</div>
									<div class="item-div">{{ item.createTime || "-" }}</div>
									<div class="item-div">{{ item.status || "-" }}</div>
								</div>
							</div>
						</div>
						<!-- 保养列表 -->
						<div class="list-item" v-if="
                type === 'maintainPage' ||
                type === 'findMaintainExecutingPage' ||
                type === 'equMaintainPage'
              ">
							<div class="list-item" v-for="(item, index) in dataList" :key="index">
								<div class="cl-item">
									<div class="item-div">
										{{ item.hospitalName || "-" }}
									</div>
									<div class="item-div">{{ item.orderNum || "-" }}</div>
									<div class="item-div">
										{{ item.departName || "-" }}
									</div>
									<div class="item-div">{{ item.equName || "-" }}</div>
									<div class="item-div">{{ item.model || "-" }}</div>
									<div class="item-div">{{ item.sn || "-" }}</div>
									<div class="item-div">
										{{ item.maintainDate || "-" }}
									</div>

									<div class="item-div">{{ item.warrantyStatus || "-" }}</div>
									<div class="item-div">{{ item.measureType || "-" }}</div>
									<div class="item-div">{{ item.maintainUserName || "-" }}</div>
									<div class="item-div">{{ item.status || "-" }}</div>
								</div>
							</div>
						</div>
						<!-- 巡检列表 -->
						<div class="list-item" v-if="
                type === 'inspectPage' ||
                type === 'findInspectExecutingPage' ||
                type === 'equInspectPage'
              ">
							<div class="list-item" v-for="(item, index) in dataList" :key="index">
								<div class="cl-item">
									<div class="item-div">
										{{ item.hospitalName || "-" }}
									</div>
									<div class="item-div">{{ item.planName || "-" }}</div>
									<div class="item-div">
										{{ item.createTime || "-" }}
									</div>
									<div class="item-div">{{ item.orderNum || "-" }}</div>
									<div class="item-div">{{ item.status || "-" }}</div>
									<div class="item-div">{{ item.departName || "-" }}</div>
									<div class="item-div">{{ item.equNum || "-" }}</div>
									<div class="item-div">{{ item.finishNum || "-" }}</div>
									<div class="item-div">{{ item.errNum || "-" }}</div>
									<div class="item-div">{{ item.closeTime || "-" }}</div>
									<div class="item-div">{{ item.inspectUserName || "-" }}</div>
								</div>
							</div>
						</div>
						<!--  -->
						<div class="list-item" v-if=" type === 'ranking'">
							<div class="list-item" v-for="(item, index) in dataList" :key="index">
								<div class="cl-item">
									<div class="item-div">
										{{ item.hospitalName || "-" }}
									</div>
									<div class="item-div">{{ item.userName || "-" }}</div>
									<div class="item-div">
										{{ item.repairNum || "-" }}
									</div>
									<div class="item-div">{{ item.maintainNum || "-" }}</div>
									<div class="item-div">{{ item.inspectNum || "-" }}</div>
								</div>
							</div>
						</div>
						<!-- v-if="dataList.length == 0" -->
						<div class="empty" v-if="dataList.length == 0">
							暂无数据
						</div>

						<!-- END -->
					</div>
				</div>
			</div>
			<!-- 分页 -->
			<div class="paging">
				<!-- @size-change="sizeChange" @current-change="pageChangeList" -->
				<el-pagination background :current-page="pageNum" class="pagination" :page-sizes="[10, 20, 30, 40]"
					:page-size="pagesSize" layout="prev, pager, next, total, sizes, jumper" :total="pagesTotal"
					@size-change="handleSizeChange" @current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import allDetails from '@/components/all-details'
import util from '@/utils/util.js'
export default {
  props: {
    hospitalList: {
      // 医院列表
      type: Array,
      default: []
    },
    hospitalId: {
      type: String,
      default: null
    },
    dataList: {
      // 分页数据
      type: Array,
      default: []
    },
    type: {
      //
      type: String,
      default: ''
    },
    pages: {
      type: Object,
      default: () => {}
    },
    // 所有医院管理类型
    managementTypeList: {
      type: Array,
      default: []
    },
    allEnumsData: {
      type: Object,
      default: () => {}
    },
    date: {
      // 年月 0000-00
      type: String,
      default: ''
    },
    currentStatus: {
      type: String,
      default: null
    },
    isDepartment: { // 是否是科室
      type: Boolean,
      default: false
    },
    departId:{ // 科室ID
      type:String,
      default:null
    },
    departList:{ // 科室列表
      type:Array,
      default:[]
    }
  },
  components: {
    allDetails
  },
  data () {
    return {
      util,
      searchParam: {
        management_type: null,
        default_hospital: null,
        many: null,
        equ_maintain_warranty_status: null,
        inspectExecutingStatus: null,
        maintainExecutingStatus: null,
        inspectTime: this.date
      },
      dateUnfinished: true, // 不是关单结束，显示多少天内没完成的选择
      dateFormat: 'yyyy年 M月份', // 时间显示格式
      dateType: this.date,
      // 维修工单状态
      repairStatus: [{
        name: '全部工单',
        value: null
      },
      {
        name: '等待确认',
        value: 'pending'
      },
      {
        name: '正在维修',
        value: 'processing'
      },
      {
        name: '等待验收',
        value: 'confirmed'
      },
      {
        name: '等待关单',
        value: 'cost'
      },
      {
        name: '关单结束',
        value: 'success'
      },
      {
        name: '取消报修',
        value: 'canceled'
      }
      ],
      // 维修工单多少天内未完成
      manyUnfinished: [{
        name: '全部工单',
        value: null
      },
      {
        name: '3天内未完成',
        value: '3'
      },
      {
        name: '7天内未完成',
        value: '7'
      }
      ],
      // 正在巡检状态
      inspectExecutingList: [{
        name: '全部状态',
        value: null
      },
      {
        name: '巡检中',
        value: 'processing'
      },
      {
        name: '未巡检',
        value: 'waiting'
      }
      ],
      // 正在保养状态
      MaintainExecutingList: [{
        name: '全部状态',
        value: null
      },
      {
        name: '等待确认',
        value: 'pending'
      },
      {
        name: '正在处理',
        value: 'processing'
      },
      {
        name: '等待验收',
        value: 'processing'
      },
      {
        name: '等待关单',
        value: 'processing'
      }
      ],

      // 品类
      categoryList: [{
        name: '全部品类',
        value: null
      },
      {
        name: 'CT品类',
        value: '06-02-01'
      },
      {
        name: 'MR品类',
        value: '06-09'
      },
      {
        name: 'DR品类',
        value: '06-01'
      },
      {
        name: 'CR品类',
        value: '06-04-03'
      },
      {
        name: 'DSA品类',
        value: '06-01-01'
      },
      {
        name: 'MRI品类',
        value: '06-17-03'
      }
      ],
      //
      repairListType: [
        '医院名称',
        '科室名称',
        '设备名称',
        '设备型号',
        '设备序列号',
        '报修人',
        '报修时间',
        '当前负责人',
        '维修天数',
        '工单状态',
        '完成时间'
      ],
      equPageList: [
        '医院名称',
        '设备二维码',
        '所属科室',
        '设备名称',
        '设备型号',
        '设备序列号',
        '设备分类',
        '保修类型',
        '计量类型',
        '盘查时间',

        '设备状态'
      ],
      maintainPageList: [
        '医院名称',
        '保养单号',
        '所属科室',
        '设备名称',
        '设备型号',
        '设备序列号',
        '保养时间',
        '保修类型',
        '计量类型',
        '保养人',
        '工单状态'
      ],
      inspectPageList: [
        '所属医院',
        '巡检计划',
        '巡检日期',
        '巡检单号',
        '巡检状态',
        '巡检科室',
        '巡检设备数',
        '已巡检设备数',
        '异常设备数',
        '关单日期',
        '巡检人'
      ],
      engineerRanking: [
        '医院名称',
        '工程师',
        '维修数量',
        '保养数量',
        '巡检数量'
      ],
      // 查询提交的数据
      infor: {
        hospitalName: '', // 医院名称
        hospitalId: null, // 医院id
        status: null, // 设备
        days: '', // 多少天未完成
        reportStartTime: '', // 开始时间
        reportEndTime: '', // 结束时间
        EquMaintainWarrantyStatus: null, // 保修类型
        managementType: '', // 管理类型
        inspectExecutingStatus: '', // 正在巡检
        inspectStatus: null, // 正在执行巡检
        MaintainExecutingStatus: '', // 正在保养
        ExecutingMaintainStatus: null, // 正在执行保养
        startMonth: '', // 开始年月
        endMonth: '', // 结束年月
        meteringStatus: null, // 计量类型
        equValue: null, // 设备价值
        category: null, // 品类
        unfinishedStatus: null, // 多少天未完成天状态
        departId:null // 科室ID
      },
      EquStatusList: []
    }
  },
  created () {
    console.log('创建后')
    if (this.hospitalId) {
      this.infor.hospitalId = this.hospitalId
    }
    if(this.isDepartment && this.departId){
      this.infor.departId = this.departId
    }
    if (this.currentStatus) {
      switch (this.type) {
        case 'maintenanceType':
          this.infor.EquMaintainWarrantyStatus = this.currentStatus // 保修
          break
        case 'maintainPage':
          this.infor.ExecutingMaintainStatus = this.currentStatus
          break
        case 'inspectPage':
          this.infor.inspectStatus = this.currentStatus // 执行巡检
          break
        case 'repair':
          if (this.currentStatus !== 'noSuccess') {
            this.infor.status = this.currentStatus === 'allRepair' ? null : this.currentStatus // 工单状态
          }else if(this.currentStatus === 'noSuccess'){
            this.infor.status = 'noSuccess'
          }
          break
        case 'meteringPage-imperative':
          this.infor.meteringStatus = this.currentStatus // 计量类型
          break
        case 'meteringPage-non_imperative':
          this.infor.meteringStatus = this.currentStatus // 计量类型
          break
        case 'meteringPage':
          this.infor.meteringStatus = this.currentStatus // 计量类型
          break
        case 'equPageValue':
          this.infor.equValue = this.currentStatus // 设备价值
          break
        case 'equPage':
          if (this.currentStatus && (this.currentStatus.indexOf('06-') != -1 || this.currentStatus ===
								'allEquStatus')) {
            this.infor.category = this.currentStatus === 'allEquStatus' ? null : this.currentStatus // 品类
          }
          break
        default:
      }
    }
  },
  watch: {
    hospitalId: {
      handler (val, oldval) {
        console.log('handlerID取到新值')
        this.searchParam.default_hospital = val
      }
    },
    departId: {
      handler (val, oldval) {
        console.log('departId取到新值')
         this.infor.departId = val
      }
    },
    
  },
  computed: {
    repairStatusList () {
      if (this.type === 'repair') {
        // 维修
        let all = [{
          value: '全部状态',
          name: null
        }]
        return [...all, ...this.allEnumsData.RepairStatus]
      }
    },
    equMaintainWarrantyStatusList () {
      // 保修工单状态
      if (this.type === 'maintenanceType') {
        let all = [{
          value: '全部状态',
          name: null
        }]
        return [...all, ...this.allEnumsData.EquMaintainWarrantyStatus]
      }
    },
    findExecutingMaintainStatusList () {
      // 正在执行保养工单状态
      if (this.type === 'maintainPage') {
        let objData = [{
          name: '全部状态',
          value: null
        },
        {
          name: '未完成',
          value: 'unsuccessful'
        },
        {
          name: '已完成',
          value: 'success'
        }
        ]
        return objData // this.allEnumsData.EquMaintainStatus;
      }
    },
    findExecutingInspectStatusList () {
      // 正在执行巡检工单状态
      if (this.type === 'inspectPage') {
        let objData = [{
          name: '全部工单',
          value: null
        },
        {
          name: '未完成',
          value: 'unsuccessful'
        },
        {
          name: '已完成',
          value: 'success'
        }
        ]
        return objData // this.allEnumsData.EquInspectStatus
      }
    },
    measureTypeList () {
      // 计量类型状态
      if (
        this.type === 'meteringPage-imperative' ||
					this.type === 'meteringPage-non_imperative' ||
					this.type === 'meteringPage'
      ) {
        let all = [{
          value: '全部工单',
          name: null
        }]
        return [...all, ...this.allEnumsData.MeasureType]
      }
    },
    equValueList () {
      if (this.type === 'equPageValue') {
        let objData = [{
          name: '全部设备',
          value: null
        },
        {
          name: '1万以下',
          value: 'one'
        },
        {
          name: '1万至5万',
          value: 'two'
        },
        {
          name: '5万至10万',
          value: 'three'
        },
        {
          name: '10万至50万',
          value: 'four'
        },
        {
          name: '50万以上',
          value: 'five'
        }
        ]
        return objData
      }
    },
    // 页数
    pageNum () {
      return this.pages.current
    },
    pagesSize () {
      return this.pages.size
    },
    pagesTotal () {
      return this.pages.total
    }
  },
  methods: {
    // 选择年月
    changeDateTime (e) {
      console.log(e)
      this.infor.endMonth = this.util.endMonth(e)
      this.infor.startMonth = this.util.startMonth(e)
      this.dateType = this.util.formatYearTime(e)
    },
    // 设置表头行的样式
    hide () {
      this.$emit('Hide', false)
    },
    handleSizeChange (val) {
      console.log(`每页 ${val} 条`)
      let valu = {
        size: val,
        type: this.type
      }
      this.$emit('getSizePages', valu)
    },
    handleCurrentChange (val) {
      console.log(`当前页: ${val}`)
      let valu = {
        page: val,
        type: this.type
      }
      this.$emit('getPages', valu)
    },
    changeHospital (e) {
      // 选择医院
      this.hospitalList.forEach((item) => {
        if (item.hospitalId === e) {
          console.log(this.infor);
          (this.infor.hospitalName = item.hospitalName), // 医院名称
          (this.infor.hospitalId = item.hospitalId) // 医院id
        }
      })
      this.query()
    },
    changeStatus (statusValue) {
      // 选择工单状态
      this.infor.status = statusValue // 工单状态
      if (this.infor.status === 'success' || this.infor.status === 'canceled') {
        this.dateUnfinished = false
      } else {
        this.dateUnfinished = true
      }

      console.log(this.infor)
    },
    // 选择维修工单多少天内未完成
    changeDays (days) {
      console.log(days)
      let time = {}
      let repairList = this.repairStatusList
      if (days) {
        time = this.util.getBeforeTime(days)
        if (time.str && time.end) {
          this.infor.reportStartTime = time.str
          this.infor.reportEndTime = time.end
        }
        this.infor.unfinishedStatus = 'noSuccess'
      } else {
        this.infor.reportStartTime = ''
        this.infor.reportEndTime = ''
        this.unfinishedStatus = ''
      }

      console.log(time)
      // this.infor.days = statusValue // 工单状态
    },
    // 选择管理类型
    changeManagementType (type) {
      this.infor.managementType = type
    },
    // 选择保修类型
    changeEquMaintainWarrantyStatus (e) {
      console.log(e)

      this.infor.EquMaintainWarrantyStatus = this.currentStatus
      this.infor.EquMaintainWarrantyStatus = e
    },
    // 选择正在巡检
    changeInspectExecutingStatus (e) {
      this.infor.inspectExecutingStatus = e
    },
    // 选择正在执行巡检
    changeInspectStatus (e) {
      this.infor.inspectStatus = e
    },
    // 选择正在保养
    changeMaintainExecutingStatus (e) {
      this.infor.maintainExecutingStatus = e
    },
    // 选择正在执行保养
    changeExecutingMaintainStatus (e) {
      this.infor.ExecutingMaintainStatus = e
    },
    changeMeteringStatus (e) {
      this.infor.meteringStatus = e
    },
    // 选择设备价值
    changeEquValue (e) {
      this.infor.equValue = e
    },
    changeCategory (e) {
      this.infor.category = e
    },
    // 选择科室
    changeDepartId(e){
      this.infor.departId = e
    },
    query () {
      // 查询
      let data = {
        status: null, // 工单状态
        hospitalId: null, // 医院id
        hospitalName: null, // 医院名称
        reportStartTime: null, // 开始时间
        reportEndTime: null, // 结束时间
        EquMaintainWarrantyStatus: null, // 保修类型
        managementType: null, // 管理类型
        inspectExecutingStatus: null, // 正在巡检
        inspectStatus: null, // 正在执行巡检
        maintainExecutingStatus: null, // 正在保养
        ExecutingMaintainStatus: null, // 正在执行保养
        type: this.type,
        endMonth: null, // 结束年月
        startMonth: null, // 开始年月
        meteringStatus: null, // 计量类型
        equValue: null, // 设备价值
        category: null, // 品类
        departId:null // 科室
      }
      // ----- 维修选择框 -----
      if (this.infor.hospitalId) { // 医院
        (data.hospitalId = this.infor.hospitalId),
        (data.hospitalName = this.infor.hospitalName)
      }
      if( this.infor.departId ){ // 科室
        data.departId = this.infor.departId
      }
      if (this.infor.status) {
        data.status = this.infor.status
      } else if (this.searchParam.repair_type === 'cost' || this.searchParam.repair_type === 'confirmed') {
        data.status = this.searchParam.repair_type
      }
      // 维修工单多少天内未完成
      if (this.infor.reportStartTime && this.infor.reportEndTime) {
        data.reportStartTime = this.infor.reportStartTime
        data.reportEndTime = this.infor.reportEndTime
        if (!this.infor.status) {
          data.status = this.infor.unfinishedStatus
        }
      }
      // 选择管理类型
      if (this.infor.managementType) {
        data.managementType = this.infor.managementType
      }

      // 选择保修类型
      if (this.infor.EquMaintainWarrantyStatus) {
        data.EquMaintainWarrantyStatus = this.infor.EquMaintainWarrantyStatus
      }
      // 选择正在巡检
      if (this.infor.inspectExecutingStatus) {
        data.inspectExecutingStatus = this.infor.inspectExecutingStatus
      }
      // 选择正在执行巡检
      if (this.infor.inspectStatus) {
        data.inspectStatus = this.infor.inspectStatus
      }
      // 选择正在保养
      if (this.infor.maintainExecutingStatus) {
        data.maintainExecutingStatus = this.infor.maintainExecutingStatus
      }
      // 选择正在执行保养
      if (this.infor.ExecutingMaintainStatus) {
        data.ExecutingMaintainStatus = this.infor.ExecutingMaintainStatus
      }
      if (this.infor.startMonth && this.infor.endMonth) {
        data.startMonth = this.infor.startMonth
        data.endMonth = this.infor.endMonth
      }
      if (this.infor.meteringStatus) {
        data.meteringStatus = this.infor.meteringStatus
      }
      if (this.infor.equValue) {
        data.equValue = this.infor.equValue
      }
      // 品类
      if (this.infor.category) {
        data.category = this.infor.category
      }
      data = this.util.removePropertyOfNull(data) // 清除对象空值和null
      console.log('查询参数', data)
      this.$emit('dateParam', data)
    }
  }
}
</script>
<style>
	.el-select-dropdown {
		background-color: #072152;
		border: 1px solid #254b92;
	}

	.el-select-dropdown__item.hover {
		background-color: #072152;
	}

	/* .monthPicker /deep/.el-input__inner {
  padding-left: 10px;
  padding-right: 10px;
  height: 40px !important;
  border: 1px solid #1d418d;
  border-radius: 8px;
  color: #8daff8;
  background-color: #112b62;
} */
</style>
<style scoped>
	/* 选择框个别样式在同级 letPopup组件 在没有scoped的style中 */
	.details-icon {
		position: absolute;
		top: 310px;
		right: 20px;
		background-image: url("../assets/right-arrow.png");
		background-repeat: no-repeat;
		z-index: 999;
		width: 19px;
		height: 34px;
	}

	.details-type {
		height: 50px;
		display: flex;
		justify-content: space-between;
		align-content: center;
		align-items: center;
	}

	.details {
		padding: 21px 200px 21px 38px;
	}

	.type-text {
		font-size: 22px;
		font-weight: bold;
		background-image: linear-gradient(#e2ebff, #6da7ff);
		background-clip: text;
		-webkit-background-clip: text;
		color: transparent;
	}

	/* 选择框 */
	.screen {
		flex: 1;
		display: flex;
		justify-content: end;
		height: 40px;
	}

	.elSelect {}

	.departSelect {
		width: 130px;
		margin-left: 10px;
	}

	.departSelect /deep/ .el-input .el-input__inner {
		height: 40px !important;
		border: 1px solid #1d418d;
		border-radius: 8px;
		color: #8daff8;
		background-color: #112b62;
	}

	.option {
		background-color: #1d418d;
	}

	.elButton {
		background-color: #1664ff;
		border: none;
		border-radius: 8px;
		width: 86px;
		font-size: 12px;
		margin-left: 12px;
	}

	.monthPicker {
		width: 120px;
		height: 40px;
		margin-left: 5px;
	}

	.monthPicker /deep/.el-input--mini .el-input__icon {
		display: none !important;
	}

	.monthPicker /deep/.el-input--mini .el-input__inner {
		padding-left: 10px;
		padding-right: 10px;
		height: 40px !important;
		border: 1px solid #1d418d;
		border-radius: 8px;
		color: #8daff8;
		background-color: #112b62;
	}

	/* list */
	.list-info {
		width: 1128px;
		height: 510px;
		padding: 23px 0 15px;
	}

	/* .table /deep/ .el-table__header-wrapper .el-table__header .has-gutter  th.el-table__cell{
    background-color: #072152;
    border: 1px solid #254B92;
} */
	.list {
		padding-top: 12px;
		height: 480px;
		overflow-x: hidden;
		overflow-y: scroll;
	}

	/*设置宽度,轨道颜色*/
	.list::-webkit-scrollbar {
		width: 8px;
		height: 8px;
		padding-right: 2px;
	}

	.list::-webkit-scrollbar-thumb {
		background: #a2c6f9;
		border-radius: 8px;
	}

	.list-type {
		width: 1120px;
		height: 38px;
		background-color: #072152;
		border: 1px solid #254b92;
		border-radius: 4px;
		display: flex;
		align-items: center;
		color: #a2c6f9;
		font-size: 14px;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.list-type-item {
		width: 100%;
		text-align: center;
		padding-right: 16px;
	}

	.cl-item {
		font-size: 14px;
		color: #fff;
		display: flex;
		padding: 0 20px;
		background-color: #071632;
		border-radius: 4px;
		border: 1px solid #152d58;
		height: 34px;
		line-height: 34px;
		margin-bottom: 12px;
	}

	.item-div {
		/* width: 98px; */
		width: 100%;
		text-align: center;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		padding-right: 16px;
		box-sizing: border-box;
	}

	/* 分页 */
	.paging {
		width: 1121px;
		text-align: center;
	}

	.pagination /deep/ .btn-prev {
		color: #a2c6f9 !important;
		background-color: #072152 !important;
		border: 1px solid #254b92;
	}

	.pagination /deep/ .btn-next {
		color: #a2c6f9 !important;
		background-color: #072152 !important;
		border: 1px solid #254b92;
	}

	.pagination /deep/ .el-pager .number {
		background-color: #072152 !important;
		color: #a2c6f9;
		border-radius: 6px;
		border: 1px solid #254b92;
	}

	.pagination /deep/ .el-pager .active {
		background-color: #1664ff !important;
	}

	.pagination /deep/ .el-pagination__total {
		color: #a2c6f9;
	}

	.pagination /deep/ .el-pagination__sizes .el-select .el-input .el-input__inner {
		background-color: #072152;
		border: 1px solid #254b92;
		color: #85a5d4;
	}

	.pagination /deep/ .el-pagination__jump {
		color: #85a5d4;
	}

	.pagination /deep/ .el-pagination__jump .el-input .el-input__inner {
		background-color: #072152 !important;
		border: 1px solid #254b92;
		color: #85a5d4;
	}

	.pagination /deep/ .el-pager .more {
		background-color: #072152 !important;
		border: 1px solid #254b92;
		color: #85a5d4;
	}

	/* 空状态 */
	.empty {
		width: 100%;
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #8daff8;
	}
</style>



// WEBPACK FOOTER //
// src/components/all-details.vue